package com.merkost.handpass.sharedweb.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.Img
import org.w3c.dom.HTMLImageElement
import org.w3c.dom.events.EventListener

@Composable
fun WebFadeInImage(
    src: String,
    alt: String = "",
    onError: (() -> Unit)? = null,
    attrs: (AttrsScope<HTMLImageElement>.() -> Unit)? = null,
) {
    Img(src = src, alt = alt, attrs = {
        classes("hp-img")
        attrs?.invoke(this)
        ref { element ->
            fun markLoaded() {
                element.classList.remove("hp-img-error")
                element.classList.add("hp-loaded")
            }
            fun markFailed() {
                element.classList.add("hp-loaded")
                element.classList.add("hp-img-error")
                onError?.invoke()
            }
            val loadListener = EventListener { markLoaded() }
            val errorListener = EventListener { markFailed() }
            if (element.complete) {
                if (element.naturalWidth > 0) markLoaded() else markFailed()
            }
            element.addEventListener("load", loadListener)
            element.addEventListener("error", errorListener)
            onDispose {
                element.removeEventListener("load", loadListener)
                element.removeEventListener("error", errorListener)
            }
        }
    })
}
